import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss'],
})
export class ThankyouComponent implements OnInit, OnDestroy {
  flag: boolean = false;
  content: string = '';
  countdownText: string = '';
  signupDone: boolean = false;
  private downloadTimer?: ReturnType<typeof setInterval>;
  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation != undefined) {
      const navigationState = navigation.extras.state;
      if (navigationState != undefined) {
        this.flag = navigation.extras.state
          ? navigation.extras.state['passwordReset']
          : true;
        if (this.flag == true) {
          this.content =
            'Your new password has been set successfully. Please login with your New Password.';
          this.signupDone = true;
        }
        this.signupDone = navigation.extras.state
          ? navigation.extras.state['signupDone']
          : false;
        if (this.signupDone == false) {
          this.content =
            'Your profile request has been submitted successfully. You will be notified by email address once your identity is verified.';
        }
      }
    }
  }

  ngOnInit() {
    this.startRedirectionCountdown();
  }

  ngOnDestroy() {
    if (this.downloadTimer) {
      clearInterval(this.downloadTimer);
    }
  }

  private startRedirectionCountdown() {
    let timeleft = 10;
    this.updateCountdownText(timeleft);
    this.downloadTimer = setInterval(() => {
      timeleft -= 1;
      if (timeleft <= 0) {
        if (this.downloadTimer) {
          clearInterval(this.downloadTimer);
        }
        this.router.navigate(['login']);
        return;
      }

      this.updateCountdownText(timeleft);
    }, 1000);
  }

  private updateCountdownText(timeleft: number) {
    this.countdownText =
      'You will be redirected to the login page in ' +
      timeleft +
      ' seconds';
  }
}
